import { startOfDay, subDays } from 'date-fns';

export function retentionStartDate(
    retentionDays: number | undefined,
    now: Date = new Date(),
): Date | undefined {
    if (!retentionDays || retentionDays <= 0) return undefined;
    return startOfDay(subDays(now, retentionDays));
}
